import {AbstractModel} from '../abstract-model';

export class PostbackLog extends AbstractModel {
  id: number | null = null;
  url: string = '';
  statusCode: number | null = null;
  error: string | null = null;
  duration: number | null = null;
  createdAt: Date | null = null;
}
